import * as Yup from 'yup'

const cmsBlogPostSearchFormSchema = Yup.object().shape({
  blog_post_id: Yup.number()
})

export default cmsBlogPostSearchFormSchema
